/** Карточка профиля в шапке: редактирует имя и управляет сессией пользователя. */
import { useEffect, useState } from "react";
import { useForm } from "@tanstack/react-form";
import { Link, useNavigate } from "react-router-dom";
import { apiHooks, UserRole } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { clearAccessToken, useAuthStore } from "@/shared/store";
import { UIKit } from "@/shared/ui";

export const ProfileCard = () => {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	const role = useAuthStore((state) => state.role);
	const userApi = apiHooks.users.useCurrentUser();
	const updateUserApi = apiHooks.users.useUpdateCurrentUser();
	const profileForm = useForm({
		defaultValues: { name: userApi.data?.name ?? "" },
		onSubmit: async ({ value }) => {
			await updateUserApi.execute({ name: value.name || null });
			await userApi.refetch();
		},
	});
	const logout = () => {
		clearAccessToken();
		void navigate(routerPaths.home);
	};
	useEffect(() => {
		const closeOutside = (event: PointerEvent) => {
			if (event.target instanceof Element && event.target.closest("[data-profile-card]")) return;
			setIsOpen(false);
		};
		window.addEventListener("pointerdown", closeOutside);
		return () => window.removeEventListener("pointerdown", closeOutside);
	}, []);
	return (
		<div className="relative" data-profile-card>
			<button
				type="button"
				className="flex h-8 min-w-8 items-center justify-center rounded-full bg-accent px-2 text-overlay-ink"
				title="Профиль"
				aria-expanded={isOpen}
				onClick={() => setIsOpen((open) => !open)}
			>
				<UIKit.Text as="span" className="text-sm font-semibold">
					{userApi.data?.name?.slice(0, 1).toUpperCase() ?? "П"}
				</UIKit.Text>
			</button>
			{isOpen && (
				<div className="absolute top-10 right-0 z-30 w-72 border border-border bg-surface p-4 text-ink shadow-lg">
					<UIKit.Text size="large">{userApi.data?.name || "Профиль"}</UIKit.Text>
					<UIKit.Text className="mt-1 text-ink">
						{userApi.data?.email ?? "Загружаем профиль..."}
					</UIKit.Text>
					{role === UserRole.Admin && (
						<Link
							className="mt-2 block rounded-md border border-border px-3 py-2 text-center text-sm text-ink hover:border-accent hover:text-accent"
							to={routerPaths.admin}
							onClick={() => setIsOpen(false)}
						>
							Администрирование
						</Link>
					)}
					<form className="mt-4" action={() => profileForm.handleSubmit()}>
						<UIKit.FormField form={profileForm} name="name">
							{(field) => (
								<UIKit.TextInput
									label="Имя"
									name={field.name}
									value={field.state.value}
									onChange={field.handleChange}
									autoComplete="name"
								/>
							)}
						</UIKit.FormField>
						<UIKit.Button className="mt-3 w-full" type="submit" disabled={updateUserApi.isPending}>
							Сохранить профиль
						</UIKit.Button>
					</form>
					<div className="mt-3 border-t border-border pt-3">
						<UIKit.Button className="w-full" onClick={logout}>
							Выйти
						</UIKit.Button>
					</div>
				</div>
			)}
		</div>
	);
};
